export default __webpack_public_path__ + "static/media/Graphics_Postcard-06-min.1a174b3a.jpg";